import axios, { AxiosInstance } from 'axios';
import { environment } from '../environments/environment';

// Axios Instance used for authentication-based api requests.
export const BooksAPI: AxiosInstance = axios.create({
  baseURL: environment.BOOKS_BASE_URL,
  timeout: 20000,
});